import React, { useState } from "react";
import axios from "axios";
import Certificate from "../Certificate/Certificate";
import "./Dashboard.css";

const Dashboard = () => {
  const URL = "https://vs-certificate.onrender.com";
  const [activeTab, setActiveTab] = useState("generate");

  // Generate Certificate States
  const [employeeName, setEmployeeName] = useState("");
  const [course, setCourse] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [generatedCertificate, setGeneratedCertificate] = useState(null);
  const [generateMessage, setGenerateMessage] = useState("");

  // Verify Certificate States
  const [certificateId, setCertificateId] = useState("");
  const [verifyResult, setVerifyResult] = useState("");

  const BACKEND_URL = `${URL}/api/certificates`;

  // --- Handle Generate Certificate ---
  const handleGenerate = async (e) => {
    e.preventDefault();
    if (!employeeName || !course || !startDate || !endDate) return;

    setGenerateMessage("⏳ Generating certificate...");
    setGeneratedCertificate(null);

    try {
      // 🔹 Wake up Render backend (helps with cold start)
      await axios.get(`${URL}/ping`).catch(() => {});

      // 🔹 Try generating certificate (retry once if first fails)
      let res;
      try {
        res = await axios.post(`${BACKEND_URL}/generate`, {
          employeeName,
          course,
          startDate,
          endDate,
        });
      } catch (error) {
        console.warn("First request failed, retrying...");
        await new Promise((r) => setTimeout(r, 1500)); // small delay
        res = await axios.post(`${BACKEND_URL}/generate`, {
          employeeName,
          course,
          startDate,
          endDate,
        });
      }

      if (res && res.status === 200) {
        setGeneratedCertificate(res.data.certificate);
        setCertificateId(res?.data?.certificate?.certificateId);
        setGenerateMessage("✅ Certificate generated successfully!");
        setEmployeeName("");
        setCourse("");
        setStartDate("");
        setEndDate("");
      } else {
        setGenerateMessage("❌ Something went wrong. Try again.");
      }
    } catch (err) {
      console.error("Backend not reachable:", err);
      setGenerateMessage("❌ Server not responding. Please try again.");
    }
  };

  // --- Handle Verify Certificate ---
  const handleVerify = async (e) => {
    e.preventDefault();
    if (!certificateId.trim()) return;

    try {
      const res = await axios.get(`${BACKEND_URL}/verify/${certificateId.trim()}`);
      if (res.data.valid) {
        setVerifyResult(`✅ Valid Certificate for ${res.data.certificate.employeeName}`);
      } else {
        setVerifyResult("❌ Certificate not found or invalid!");
      }
    } catch (err) {
      setVerifyResult("❌ Certificate not found or invalid!");
    }
  };

  return (
    <div className="dashboard-container">
      {/* Tabs */}
      <div className="tab-buttons">
        <button
          onClick={() => setActiveTab("generate")}
          className={activeTab === "generate" ? "tab active" : "tab"}
        >
          Generate Certificate
        </button>
        <button
          onClick={() => setActiveTab("verify")}
          className={activeTab === "verify" ? "tab active" : "tab"}
        >
          Verify Certificate
        </button>
      </div>

      {/* Generate Tab */}
      {activeTab === "generate" && (
        <div className="tab-section">
          <h1 className="section-title">Generate Internship Certificate</h1>
          <form onSubmit={handleGenerate} className="form-container">
            <input
              type="text"
              placeholder="Employee Name"
              value={employeeName}
              onChange={(e) => setEmployeeName(e.target.value)}
              required
            />
            <input
              type="text"
              placeholder="Course / Domain"
              value={course}
              onChange={(e) => setCourse(e.target.value)}
              required
            />

            <div className="date-group">
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                required
              />
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn-generate">
              Generate Certificate
            </button>
          </form>

          {generateMessage && <p className="generate-msg">{generateMessage}</p>}
          {generatedCertificate && <Certificate generatedCertificate={generatedCertificate} />}
        </div>
      )}

      {/* Verify Tab */}
      {activeTab === "verify" && (
        <div className="tab-section">
          <h1 className="section-title">Verify Certificate</h1>
          <form onSubmit={handleVerify} className="form-container">
            <input
              type="text"
              placeholder="Enter Certificate ID"
              value={certificateId}
              onChange={(e) => setCertificateId(e.target.value)}
              required
            />
            <button type="submit" className="btn-verify">
              Verify
            </button>
          </form>

          {verifyResult && <p className="verify-msg">{verifyResult}</p>}
        </div>
      )}
    </div>
  );
};

export default Dashboard;